import * as React from "react";
import * as Yup from "yup";
import axios from "axios";
import { Formik } from "formik";
import { mailDomainsBlacklist } from '../utils/utils.js';

const PORTAL_ID = '7284441';
const FORM_ID_DEFAULT = '971fbcd5-ddce-41ff-a62e-f34a7b4b2363';

function toFormGroupClass(field, state, error) {
  if (state.touched[field] && (state.errors[field] || error)) {
    return "pt-form-group pt-intent-danger";
  } else if (
    state.touched[field] &&
    state.values &&
    state.values[field] !== ""
  ) {
    return "pt-form-group pt-intent-success";
  } else {
    return "pt-form-group";
  }
} 

export class DemoFormShortPDFAprilFools extends React.Component {
   constructor(props) {
    super(props);
    this.state = { error: false, mailError: false, submitted: false, scrolled: false };
  }

  validationSchema = Yup.object().shape({  	   
    email: Yup.string()
      .email("Must be a valid email")
      //.matches(mailDomainsBlacklist, "Company Email Only")
      .required("Required")
  });
  

  handleSubmit = (values, { resetForm }) => {    
    window.open(this.props.pdfUrl,'_blank');

    const url = typeof window !== 'undefined' ? window.location.href : '';
    const pageTitle = typeof document !== 'undefined' ? document.title : '';

    const UTMparams = JSON.parse(sessionStorage.getItem('UTMparams'));

    const fields = [ {name: 'email', value: values.email} ]

    if (UTMparams && typeof UTMparams[0] === "string" ){
      fields.push({name: UTMparams[0], value: UTMparams[1]})

    } else if (UTMparams) {
      UTMparams.forEach(property => {
        fields.push({name: property[0], value: property[1]})
      })
    }

    const context = {
      pageUri: url,
      pageName: pageTitle
    }

    let form_id;

    form_id = FORM_ID_DEFAULT;

    values.source = this.props.source;

    // ============ Sending to Hubspot ============ // 
    axios.request({
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
      },
      url: `https://api.hsforms.com/submissions/v3/integration/submit/${PORTAL_ID}/${form_id}`,
      data: JSON.stringify({
        fields: fields,
        context: context
      })
    })
    .then(res=>{
      this.setState({ submitted: true });
      this.btn.setAttribute("disabled", "disabled");
      this.btn.removeAttribute("disabled");
    }) 
    .catch(error => {
      this.setState({ error: true })
      return
    })

    // ============ Sending to Charthop API (Slack) ============ // 
    axios 
      .request({
        method: "POST",
        url: "https://api.charthop.com/contact",
        data: { ...values }
      })


  };

  render() {
    if (this.state.submitted) {

      return (
       
        <div className="pt-callout pt-intent-primary pt-submission-success">                  	
          Great! We'll email you with a copy.<br></br>
          To download the PDF <a href={this.props.pdfUrl} target="_blank"><u>click here.</u></a>
          {/* {titleToggleJS()} */}
        </div>
        
      );
    }

    return (
      <Formik
       initialValues={{ email: ""}}
        validationSchema={this.validationSchema}
        onSubmit={this.handleSubmit} 
        render={form => (          
          <form className="demoshortform" onSubmit={form.handleSubmit} >
            <div className="inputrow">
              <div className={toFormGroupClass("email", form)} >              
                <input
                  id="email"
                  type="email"
                  class="companyEmail"
                  value={form.values.email}
                  onChange={form.handleChange}
                  placeholder="Email Address"
                />
                {form.touched.email && form.errors.email && (
                  <div className="pt-form-helper-text">{form.errors.email}</div>
                )}              
              </div> 
              <button ref={btn => { this.btn = btn; }} type="submit" className="button primary">
                DOWNLOAD
              </button>            
            </div>
            <p className="p-formPDF opt-in pt-0 pb-0 mb-0">By downloading this PDF, you agree to opt-in to emails from ChartHop.</p> 

            {this.state.mailError && (
              <div
                className="pt-callout pt-intent-danger"
                style={{ marginTop: 10 }}
              >
                <p className="p-maxwidth errorTextHeaderForm"><span role="img" aria-label="warning">&#128680;</span>
                  Sorry! Please use a company email. If your issue persists, send a note to {" "}
                  <a href="mailto:hello@charthop.com">hello@charthop.com</a>.
                </p>
              </div>
            )}

            {this.state.error && (
              <div
                className="pt-callout pt-intent-danger"
                style={{ marginTop: 10 }}
              >
                <p className="p-maxwidth errorTextHeaderForm"><span role="img" aria-label="warning">&#128680;</span>
                Sorry, but we had an unexpected problem submitting your request.
                Try again later, or send a note to {" "}
                <a href="mailto:hello@charthop.com">hello@charthop.com</a>.</p>
              </div>
            )}
          </form>          
        )}
      />
    );
  }
}
